module.exports = __webpack_public_path__ + "static/media/circle-arrow.7d27321b.svg";